import { render, staticRenderFns } from "./UILegalDisclaimerModal.vue?vue&type=template&id=20f4eb3c"
import script from "./UILegalDisclaimerModal.vue?vue&type=script&lang=js"
export * from "./UILegalDisclaimerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default,Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
